
import Vue from 'vue';
import { Component, Provide } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import {
  GroupType,
  KindType,
  PlaceOfUseType,
  SettingsApiControllerUIClient,
  TestEquipmentDevice,
  TestEquipmentGroupTypeAPIControllerUIClient,
  TestEquipmentKindTypeAPIControllerUIClient,
  TestEquipmentPlaceOfUseAPIControllerUIClient,
  TestEquipmentTimeUnitAPIControllerUIClient,
  TimeUnit,
} from '../../backend/backendapi';
import { RiskOption, RiskOptionSetting } from '../archivemodal/archivemodal.model';
import TestEquipmentList from '../list/TestEquipmentList';
import State from '../State';
import MeasurementSpecificationTemplates from '../measurementSpecificationTemplates/MeasurementSpecificationTemplates';
import moment from 'moment';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    MeasurementSpecificationTemplates,
    TestEquipmentList,
    Abstract: require('../abstract/abstract.vue.html').default,
  },
})
export default class TestEquipmentMain extends Vue {
  currentTab: number = 0;

  @Provide('state')
  readonly state = new State();

  filterFunction = 'archived = false ' +
      'AND (' +
      '  nextTestDate < \'' + moment().startOf('day').add(1, 'day').toISOString() + '\'' +
      '  OR ' +
      '  (nextTestWarningDate IS NOT null AND nextTestWarningDate < \'' + moment().startOf('day').add(1, 'day').toISOString() + '\')' +
      ')';
  unarchivedFunction = 'archived = false';
  archivedFunction = 'archived = true';

  editEquipment: TestEquipmentDevice = new TestEquipmentDevice();

  private readonly kindAPI = initClient(TestEquipmentKindTypeAPIControllerUIClient);
  private readonly groupAPI = initClient(TestEquipmentGroupTypeAPIControllerUIClient);
  private readonly placeofuseAPI = initClient(TestEquipmentPlaceOfUseAPIControllerUIClient);
  private readonly timeunitAPI = initClient(TestEquipmentTimeUnitAPIControllerUIClient);
  private readonly settingsApi = initClient(SettingsApiControllerUIClient);

  get KindTypeInstanciator(): any {
    return (init?) => new KindType(init);
  }

  get GroupTypeInstanciator(): any {
    return (init?) => new GroupType(init);
  }

  get PlaceOfUseTypeInstanciator(): any {
    return (init?) => new PlaceOfUseType(init);
  }

  get TimeUnitInstanciator(): any {
    return (init?) => new TimeUnit(init);
  }

  mounted(): void {
    this.reloadAll();
  }

  async reloadAll(): Promise<void> {
    await this.state.kindsStore.reload();
    await this.state.groupsStore.reload();
    await this.state.placeOfUsesStore.reload();
    await this.state.timeUnitsStore.reload();
    await this.reloadRiskOptions(); //reload this first
  }

  async reloadRiskOptions(): Promise<void> {
    let obj = (await this.settingsApi.getSystemSetting('testequipment.riskoptions')).result!;
    let set = new RiskOptionSetting();
    Object.keys(obj).forEach(lang => {
      let options: RiskOption[] = [];
      set[lang] = options;
      Object.keys(obj[lang]).forEach(id => {
        options.push({ id: id, name: obj[lang][id] } as RiskOption);
      });
    });
    this.state.riskOptionsSetting = set;
  }
}
